/**
 */
export class User {
    userId: number;
    loginId: string;
    name: string;
    email: string;
    userRole: string;
    disabled: boolean;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/user.model.ts